type APIConfig = {
  url: string
}

type Config = {
  api: APIConfig
}

declare const APP_CONFIG: Config
export const CONFIG = APP_CONFIG

export const API_PATH =
  process.env.NODE_ENV !== "development" ? process.env.REACT_APP_API : ""
